import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';

const styles = {
  container: {
    marginTop: 0
  }
}

class RowContainer extends Component {
  render() {
    return (
      <div style={styles.container}>
        {this.props.children}
      </div>
    );
  }
}
export default RowContainer;



// WEBPACK FOOTER //
// ./src/pages/auth/containers/Row.tsx